(function () {
    'use strict';

    AntiForgeryService.$inject = ['cookieService'];

    function AntiForgeryService(cookieService) {
        var key = 'XSRF-TOKEN';

        var service = {
            getToken: getToken,
            setToken: setToken
        };

        return service;

        function getToken() {
            return cookieService.get(key);
        }

        function setToken(token) {
            cookieService.put(key, token);
        }
    }

    module.exports = AntiForgeryService;
})();